/* eslint-disable */
import { IModel } from '@/@types/models/model';
import coreFields from '../helpers/coreFields';
import buttonFields from '../helpers/buttonFields';
import commonFields from '../helpers/commonFields';

const GrobnaMjesta: IModel = {
  title: 'Grobna mjesta',
  apiPath: 'groblja/grobna-mjesta',
  layer: 'grobna_mjesta',
  forms: {
    default: {
      fields: [
        'groblje_id',
        'odjel',
        'razred',
        'polozaj',
        'polje',
        'red',
        'broj',
        'vrsta_id',
        'status_id',
        'external_id',
        'ocevidnik_knjiga_broj',
        'ocevidnik_knjiga_strana',
        'ocevidnik_knjiga_redni_broj',
        'ocevidnik_pomocna_knjiga_broj',
        'ocevidnik_pomocna_knjiga_strana',
        'ocevidnik_pomocna_knjiga_redni_broj',
        'napomena',
        'geom',
      ],
      layout: [
        {
          title: 'Lokacija',
          columns: 1,
          fieldNames: ['groblje_id'],
        },
        {
          columns: 3,
          fieldNames: ['odjel', 'razred', 'polozaj','polje', 'red', 'broj'],
        },
        {
          title: 'groblja:sections.podaci_o_grobnom_mjestu',
          columns: 3,
          fieldNames: ['vrsta_id', 'status_id'],
        },
        {
          title: 'groblja:sections.knjiga_ocevidnika',
          columns: 3,
          fieldNames: ['ocevidnik_knjiga_broj', 'ocevidnik_knjiga_strana', 'ocevidnik_knjiga_redni_broj'],
        },
        {
          title: 'groblja:sections.pomocna_knjiga',
          columns: 3,
          fieldNames: ['ocevidnik_pomocna_knjiga_broj', 'ocevidnik_pomocna_knjiga_strana', 'ocevidnik_pomocna_knjiga_redni_broj'],
        },
        {
          title: 'common.ostalo',
          columns: 1,
          fieldNames: ['external_id', 'napomena', 'geom'],
        },
      ],
    },
    grobno_mjesto_info_card: {
      fields: ['groblje_label', 'odjel', 'razred', 'polozaj','polje', 'red', 'broj', 'vrsta_label', 'status_label'],
    },
  },
  listViews: {
    default: {
      fields: [
        'id',
        'groblje_id',
        'odjel',
        'razred',
        'polozaj',
        'polje',
        'red',
        'broj',
        'vrsta_id',
        'status_id',
        'external_id',
        'ocevidnik_knjiga_broj',
        'ocevidnik_knjiga_strana',
        'ocevidnik_knjiga_redni_broj',
        'ocevidnik_pomocna_knjiga_broj',
        'ocevidnik_pomocna_knjiga_strana',
        'ocevidnik_pomocna_knjiga_redni_broj',
        'napomena',
        'docs',
        'btn_show_history',
      ],
      hidden: [
        'id',
        'external_id',
        'ocevidnik_knjiga_broj',
        'ocevidnik_knjiga_strana',
        'ocevidnik_knjiga_redni_broj',
        'ocevidnik_pomocna_knjiga_broj',
        'ocevidnik_pomocna_knjiga_strana',
        'ocevidnik_pomocna_knjiga_redni_broj',
      ],
    },
    history: {
      fields: [
        'id',
        'groblje_id',
        'odjel',
        'razred',
        'polozaj',
        'polje',
        'red',
        'broj',
        'vrsta_id',
        'status_id',
        'external_id',
        'ocevidnik_knjiga_broj',
        'ocevidnik_knjiga_strana',
        'ocevidnik_knjiga_redni_broj',
        'ocevidnik_pomocna_knjiga_broj',
        'ocevidnik_pomocna_knjiga_strana',
        'ocevidnik_pomocna_knjiga_redni_broj',
        'napomena',
        'docs',
        'edited',
      ],
      hidden: [
        'id',
        'external_id',
        'ocevidnik_knjiga_broj',
        'ocevidnik_knjiga_strana',
        'ocevidnik_knjiga_redni_broj',
        'ocevidnik_pomocna_knjiga_broj',
        'ocevidnik_pomocna_knjiga_strana',
        'ocevidnik_pomocna_knjiga_redni_broj',
      ],
    },
  },
  fields: [
    coreFields.id,
    buttonFields.show_history,
    {
      title: 'groblje_id',
      source: 'groblje_id',
      ttoken: 'groblja:grobna_mjesta.groblje',
      type: 'picker',
      subModel: {
        apiPath: 'groblja?view=picker',
        format: '{label}',
        idattr: 'id',
      },
      validation: {
        required: true,
      },
      filter: true,
    },
    {
      type: 'boolean',
      source: 'has_history',
      title: 'has history',
      ttoken: 'common.has_history',
    },
    {
      title: 'odjel',
      source: 'odjel',
      ttoken: 'groblja:grobna_mjesta.odjel',
      type: 'text',
      filter: true,
    },
    {
      title: 'polje',
      source: 'polje',
      ttoken: 'groblja:grobna_mjesta.polje',
      type: 'text',
      filter: true,
    },
    {
      title: 'red',
      source: 'red',
      ttoken: 'groblja:grobna_mjesta.red',
      type: 'text',
      filter: true,
    },
    {
      title: 'razred',
      source: 'razred',
      ttoken: 'groblja:grobna_mjesta.razred',
      type: 'text',
      filter: true,
    },
    {
      title: 'broj',
      source: 'broj',
      ttoken: 'groblja:grobna_mjesta.broj',
      type: 'text',
      filter: true,
    },
    {
      title: 'polozaj',
      source: 'polozaj',
      ttoken: 'groblja:grobna_mjesta.polozaj',
      type: 'text',
      filter: true,
    },
    {
      title: 'vrsta_id',
      source: 'vrsta_id',
      ttoken: 'groblja:grobna_mjesta.vrsta',
      type: 'picker',
      subModel: {
        apiPath: 'groblja/grobna-mjesta/vrste',
        format: '{label}',
        idattr: 'id',
      },
      filter: true,
    },
    {
      title: 'status_id',
      source: 'status_id',
      ttoken: 'groblja:grobna_mjesta.status',
      type: 'picker',
      subModel: {
        apiPath: 'groblja/grobna-mjesta/statusi',
        format: '{label}',
        idattr: 'id',
      },
      filter: true,
    },
    {
      title: 'ocevidnik_knjiga_broj',
      source: 'ocevidnik_knjiga_broj',
      ttoken: 'groblja:grobna_mjesta.ocevidnik_knjiga_broj',
      type: 'numeric',
      filterType: 'text',
      filter: true,
    },
    {
      title: 'ocevidnik_knjiga_strana',
      source: 'ocevidnik_knjiga_strana',
      ttoken: 'groblja:grobna_mjesta.ocevidnik_knjiga_strana',
      type: 'numeric',
      filterType: 'text',
      filter: true,
    },
    {
      title: 'ocevidnik_knjiga_redni_broj',
      source: 'ocevidnik_knjiga_redni_broj',
      ttoken: 'groblja:grobna_mjesta.ocevidnik_knjiga_redni_broj',
      type: 'numeric',
      filterType: 'text',
      filter: true,
    },
    {
      title: 'ocevidnik_pomocna_knjiga_broj',
      source: 'ocevidnik_pomocna_knjiga_broj',
      ttoken: 'groblja:grobna_mjesta.ocevidnik_pomocna_knjiga_broj',
      type: 'numeric',
      filterType: 'text',
      filter: true,
    },
    {
      title: 'ocevidnik_pomocna_knjiga_strana',
      source: 'ocevidnik_pomocna_knjiga_strana',
      ttoken: 'groblja:grobna_mjesta.ocevidnik_pomocna_knjiga_strana',
      type: 'numeric',
      filterType: 'text',
      filter: true,
    },
    {
      title: 'ocevidnik_pomocna_knjiga_redni_broj',
      source: 'ocevidnik_pomocna_knjiga_redni_broj',
      ttoken: 'groblja:grobna_mjesta.ocevidnik_pomocna_knjiga_redni_broj',
      type: 'numeric',
      filterType: 'text',
      filter: true,
    },
    {
      title: 'napomena',
      source: 'napomena',
      ttoken: 'common.napomena',
      type: 'multiline',
      rows: 3,
      maxRows: 10,
      width: 'full',
      filter: true,
    },
    {
      title: 'is_deleted',
      source: 'is_deleted',
      ttoken: '',
      type: 'boolean',
      items: {
        labels: ['common.no', 'common.yes'],
        values: [false, true],
        default: false,
      },
      filter: true,
      readonly: true,
    },
    {
      title: 'edited',
      source: 'edited',
      ttoken: 'common.edited',
      type: 'datetime',
      filter: true,
    },
    {
      title: 'action',
      source: 'action',
      ttoken: 'common.action',
      type: 'picker',
      items: {
        labels: ['common.actions.update', 'common.actions.insert', 'common.actions.delete'],
        values: ['UPDATE', 'INSERT', 'DELETE'],
      },
      filter: true,
      translate: true,
      readonly: true,
    },
    {
      title: 'groblje_label',
      source: 'groblje_label',
      ttoken: 'groblja:grobna_mjesta.groblje',
      type: 'text',
      filter: true,
    },
    {
      title: 'status_label',
      source: 'status_label',
      ttoken: 'groblja:grobna_mjesta.status',
      type: 'text',
      filter: true,
    },
    {
      title: 'vrsta_label',
      source: 'vrsta_label',
      ttoken: 'groblja:grobna_mjesta.vrsta',
      type: 'text',
      filter: true,
    },
    {
      title: 'cx',
      source: 'cx',
      ttoken: 'groblja:grobna_mjesta.cx',
      type: 'numeric',
      filter: false,
    },
    {
      title: 'cy',
      source: 'cy',
      ttoken: 'groblja:grobna_mjesta.cy',
      type: 'numeric',
      filter: false,
    },

    {
      title: 'cz',
      source: 'cz',
      ttoken: 'groblja:grobna_mjesta.cz',
      type: 'numeric',
      filter: false,
    },
{
      title: 'external_id',
      source: 'external_id',
      ttoken: 'common.external_id',
      type: 'text',
      filter: true,
    },
    {
      ...coreFields.geom,
      validation: {
        required: true,
      }
    },
    coreFields.gid,
    commonFields.docsHistory,
    coreFields.created_by,
    coreFields.created_on,
    coreFields.modified_by,
    coreFields.modified_on,
  ],
};

export default GrobnaMjesta;
